import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { NAV, CONTACT } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-forest text-sand grain overflow-hidden">
    <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-20">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-4">
            <img src="/emblem.png" alt="Logo Sandro Services 06" className="h-14 w-auto" />
            <h3 className="font-display text-3xl md:text-4xl tracking-tight">
              SANDRO SERVICES <span className="text-olive">06</span>
            </h3>
          </div>
          <p className="mt-4 text-sand/70 text-sm max-w-sm">
            Entretien • Création • Restauration • Nettoyage • Petites réparations
          </p>
          <div className="mt-8 flex flex-col gap-3 text-sm">
            <a href={`tel:${CONTACT.phone}`} data-testid="footer-phone" className="inline-flex items-center gap-3 hover:text-olive transition-colors">
              <Phone size={16} /> {CONTACT.phoneDisplay}
            </a>
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="inline-flex items-center gap-3 hover:text-olive transition-colors">
              <Mail size={16} /> {CONTACT.email}
            </a>
            <span className="inline-flex items-center gap-3 text-sand/70">
              <MapPin size={16} /> {CONTACT.address}
            </span>
          </div>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-sand/50 mb-5">Navigation</p>
          <ul className="space-y-3 text-sm">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sand/80 hover:text-white transition-colors">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-sand/50 mb-5">Informations</p>
          <ul className="space-y-3 text-sm">
            <li><a href="/#realisations" className="text-sand/80 hover:text-white transition-colors">Réalisations</a></li>
            <li><a href="/#avis" className="text-sand/80 hover:text-white transition-colors">Avis clients</a></li>
            <li><Link to="/mentions-legales" className="text-sand/80 hover:text-white transition-colors">Mentions légales</Link></li>
            <li><Link to="/confidentialite" className="text-sand/80 hover:text-white transition-colors">Politique de confidentialité</Link></li>
            <li><Link to="/zone-intervention" className="text-sand/80 hover:text-white transition-colors">Zone d'intervention</Link></li>
            <li><Link to="/contact" className="text-sand/80 hover:text-white transition-colors">Demander un devis</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-sand/15 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-sand/50">
        <p>© {new Date().getFullYear()} Sandro Services 06 — Tous droits réservés.</p>
        <div className="flex items-center gap-4">
          <p>Intervention dans les Alpes-Maritimes (06)</p>
          <Link to="/admin/login" className="text-sand/40 hover:text-sand/70 transition-colors">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);
